import { create } from 'zustand';

export const APP_THEMES = [
  { value: 'aqua', label: 'PKK Pulse' },
  { value: 'crazy', label: 'Crazy Colour' },
  { value: 'grey', label: 'Grey Vibe' },
];

const DEFAULT_THEME = 'aqua';

const sanitizeTheme = (value) => {
  if (!value) return DEFAULT_THEME;
  const normalized = String(value).trim().toLowerCase();
  return APP_THEMES.some((theme) => theme.value === normalized) ? normalized : DEFAULT_THEME;
};

export const useThemeStore = create((set) => ({
  isDarkMode: false,
  appTheme: DEFAULT_THEME,

  toggleDarkMode: () =>
    set((state) => {
      const newMode = !state.isDarkMode;
      localStorage.setItem('theme', newMode ? 'dark' : 'light');
      return { isDarkMode: newMode };
    }),

  setDarkMode: (isDark) => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    set({ isDarkMode: isDark });
  },

  setAppTheme: (nextTheme) => {
    const resolvedTheme = sanitizeTheme(nextTheme);
    localStorage.setItem('appTheme', resolvedTheme);
    set({ appTheme: resolvedTheme });
  },

  initTheme: () => {
    const saved = localStorage.getItem('theme');
    const savedAppTheme = sanitizeTheme(localStorage.getItem('appTheme'));
    const isDark =
      saved === 'dark' ||
      (!saved && window.matchMedia('(prefers-color-scheme: dark)').matches);
    set({ isDarkMode: isDark, appTheme: savedAppTheme });
  },
}));
